/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HostNameApiIdApiKeyData
 */
export interface HostNameApiIdApiKeyData {
    /**
     * 
     * @type {string}
     * @memberof HostNameApiIdApiKeyData
     */
    hostName?: string;
    /**
     * 
     * @type {string}
     * @memberof HostNameApiIdApiKeyData
     */
    apiId?: string;
    /**
     * 
     * @type {string}
     * @memberof HostNameApiIdApiKeyData
     */
    apiKey?: string;
}

/**
 * Check if a given object implements the HostNameApiIdApiKeyData interface.
 */
export function instanceOfHostNameApiIdApiKeyData(value: object): value is HostNameApiIdApiKeyData {
    return true;
}

export function HostNameApiIdApiKeyDataFromJSON(json: any): HostNameApiIdApiKeyData {
    return HostNameApiIdApiKeyDataFromJSONTyped(json, false);
}

export function HostNameApiIdApiKeyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostNameApiIdApiKeyData {
    if (json == null) {
        return json;
    }
    return {
        
        'hostName': json['hostName'] == null ? undefined : json['hostName'],
        'apiId': json['apiId'] == null ? undefined : json['apiId'],
        'apiKey': json['apiKey'] == null ? undefined : json['apiKey'],
    };
}

export function HostNameApiIdApiKeyDataToJSON(json: any): HostNameApiIdApiKeyData {
    return HostNameApiIdApiKeyDataToJSONTyped(json, false);
}

export function HostNameApiIdApiKeyDataToJSONTyped(value?: HostNameApiIdApiKeyData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostName': value['hostName'],
        'apiId': value['apiId'],
        'apiKey': value['apiKey'],
    };
}

